import { routing } from "../../routing.js";
import { Query, SortOrder } from "../../types/index.js";
export function createClient(api) {
  async function list(options = {}, scope) {
    const {
      includeDeleted,
      limit,
      offset,
      search,
      sortOrder
    } = options;
    // TODO: Switch to `scope` API parameter
    const url = scope?.story ? routing.storyCoverageUrl.replace(':story_id', String(scope.story)) : routing.coverageUrl;
    return api.get(url, {
      query: {
        include_deleted: includeDeleted ? 'on' : undefined,
        limit,
        offset,
        search,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function search(options = {}, scope) {
    const {
      includeDeleted,
      search,
      query,
      limit,
      offset,
      sortOrder
    } = options;
    // TODO: Switch to `scope` API parameter
    const url = scope?.story ? routing.storyCoverageUrl.replace(':story_id', String(scope.story)) : routing.coverageUrl;
    // TODO: Introduce dedicated Search POST API
    return api.get(url, {
      query: {
        include_deleted: includeDeleted ? 'on' : undefined,
        search,
        query: Query.stringify(query),
        limit,
        offset,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function get(id, includeDeleted = false) {
    const url = `${routing.coverageUrl}/${id}`;
    const {
      coverage
    } = await api.get(url, {
      query: {
        include_deleted: includeDeleted ? 'on' : undefined
      }
    });
    return coverage;
  }
  async function getByExternalReferenceId(externalReferenceId, options = {}) {
    const query = JSON.stringify({
      external_reference_id: {
        $in: [externalReferenceId]
      }
    });
    const {
      coverage
    } = await search({
      includeDeleted: options.includeDeleted ?? true,
      query,
      sortOrder: 'deleted_at' // Prefer non-deleted records first
    });
    return coverage[0] || null;
  }
  async function create(payload, {
    enrich = false
  } = {}) {
    const {
      coverage
    } = await api.post(routing.coverageUrl, {
      payload,
      query: {
        enrich: enrich || undefined
      }
    });
    return coverage;
  }
  async function update(id, payload) {
    const {
      coverage
    } = await api.patch(`${routing.coverageUrl}/${id}`, {
      payload
    });
    return coverage;
  }
  async function doDelete(id) {
    return api.delete(`${routing.coverageUrl}/${id}`);
  }
  function bulkDelete(options) {
    const {
      selection,
      query
    } = options;
    return api.delete(routing.coverageUrl, {
      payload: {
        selection,
        query
      }
    });
  }
  return {
    list,
    search,
    get,
    getByExternalReferenceId,
    create,
    update,
    delete: doDelete,
    bulkDelete
  };
}